<template>
  <component :is="disabled ? 'span' : 'router-link'" :to="{ name: isLoggedIn ? 'ContractList' : 'Login' }" :class="logoStyle">
    <img :src="$cdnEndpoint + 'img/logo/' + fileName" alt="LeCheck" />
  </component>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    color: {
      type: String,
      required: false,
      default: 'brand'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isLefiling: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.auth.isLoggedIn;
    },
    fileName() {
      if (this.color === 'white') return 'lecheck_logo_v2.png';
      if (this.color === 'black') return 'lecheck_logo1.png';
      if (this.color === 'cloudsign_review') return 'logo_outline_cloudsign_review.png';
      if (this.isLefiling) return 'logo_lefiling_151x31.png';
      return 'logo.png';
    },
    logoStyle() {
      if (this.color === 'cloudsign_review') {
        return 'logo-cloudsign';
      }
      return 'logo';
    }
  }
};
</script>

<style scoped>
.logo {
  display: inline-block;
  width: 151px;
  height: 31px;
  min-width: 151px;
  min-height: 31px;
}
.logo-cloudsign {
  display: inline-block;
  width: 204px;
  height: 15px;
  min-width: 204px;
  min-height: 15px;
}
img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/_atoms/Logo.vue